module.exports = "/_next/static/images/row2-2-4196960bf0f52b43b08e6f6b177b1ec7.png";